import { Component, HostBinding } from '@angular/core';
import {ConstantsProviders} from '../../services/constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent{
    //Variables
    currentDate : Date = new Date();
  protected getVersion() {
    return ConstantsProviders.AppVersion;
  }
}
